import { NavLink, Outlet } from "react-router-dom";
import { Footer } from "../../component/Footer";
import "../styles/homeWrap.scss";
import { Header } from "../../component/header";

export const HomeWrap = () => {
  return (
    <div className="homeWrap">
       <Header/>
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};
